<div class="confirmation-dialog">
	<h2 mat-dialog-title>Confirm {{ action }}</h2>
	<mat-dialog-content>
		Are you sure you want to {{ action }} {{ theSubject }}?
		<p></p>
		<p *ngIf="additionalInformation != ''">
			{{ additionalInformation }}
		</p>
		<br />
		@if (!hideUltimatum) {
			<span class="flex items-center"
				><mat-icon class="mr-2 text-yellow-400">warning</mat-icon>This action cannot be undone.</span
			>
		}
	</mat-dialog-content>
	<mat-dialog-actions>
		<button mat-flat-button (click)="yes()">Yes</button>
		<button mat-button (click)="no()">No</button>
	</mat-dialog-actions>
</div>
